import { Directive, ElementRef, HostListener, output } from "@angular/core";

@Directive({
  selector: "[click-outside]",
  standalone: false,
})
export class ClickOutsideDirective {
  onOutSideClick = output();

  constructor(private elementRef: ElementRef) {}

  @HostListener("document:click", ["$event.target"])
  public onClick(target: HTMLElement): void {
    const clickedInside = this.elementRef.nativeElement.contains(target);
    if (!clickedInside) {
      this.onOutSideClick.emit();
    }
  }
}
